import React, { useEffect } from "react";
import { useMySheetCurrentRoleState } from "my-timesheet/hooks";
import MyTimesheetUserRequestsPage from "my-timesheet/pages/user-requests-page";

export const MyTimesheetExaminerUserRequestsPage = () => {
  const role = "examiner";
  const { state, setState } = useMySheetCurrentRoleState();

  useEffect(() => {
    if (state !== role) {
      setState(role);
    }
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  return <MyTimesheetUserRequestsPage role="examiner" />;
};

export default MyTimesheetExaminerUserRequestsPage;
